import React, { Fragment } from "react";
import BulkActionApproveButton from "./BulkActionApproveButton";
import BulkActionRejectButton from "./BulkActionRejectButton";
import { useListContext } from "react-admin";
import { filter } from "lodash";
import ApproveAllButton from "./ApproveAllButton";

const BulkConfirmButton = (props: any) => {
  const { data, selectedIds, filterValues } = useListContext();
  const filteredData = filter(data, (item) => selectedIds.includes(item.id));

  return (
    <Fragment>
      <BulkActionApproveButton filteredData={filteredData} {...props} />
      <BulkActionRejectButton filteredData={filteredData} {...props} />
      <ApproveAllButton
        schoolId={filterValues.SchoolId}
        subcontractorId={filterValues.SubcontractorId}
      />
    </Fragment>
  );
};

export default BulkConfirmButton;
